import {
  customRequest,
  customRequestArray,
  handleResponse,
  accountId,
} from "src/helpers";
import { buildQueryString } from "src/utils/helpers";

const config = {
  apiUrl: process.env.VUE_APP_BACKEND_URL,
};

export const invoiceService = {
  create,
  update,
  getAll,
  getById,
  delete: _delete,
  getNextNumber,
  sendEmail,
  updatePayment,
  getStatementAll,
  getStatementSummary,
  createFromQuote,
  addAttachments,
  deleteAttachments,
  getByIdFiles,
};
function getByIdFiles(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/${id}/files`, requestOptions).then(
    handleResponse
  );
}

function addAttachments(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequestArray("POST", payload.attachmentIds),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/files`,
    requestOptions
  ).then(handleResponse);
}

function deleteAttachments(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequestArray("DELETE", payload.attachmentIds),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/files`,
    requestOptions
  ).then(handleResponse);
}

function create(payload) {
  payload.invoice.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/CreateWithLines`,
    requestOptions
  ).then(handleResponse);
}

function createFromQuote(payload) {
  const requestOptions = {
    ...customRequest("POST"),
  };
  return fetch(
    `${config.apiUrl}/Quotes/${payload.quoteId}/ConvertToInvoice`,
    requestOptions
  ).then(handleResponse);
}

function updatePayment(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/payment`,
    requestOptions
  ).then(handleResponse);
}

function sendEmail(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/email`,
    requestOptions
  ).then(handleResponse);
}

function getNextNumber() {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/NextNumber`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getAll(params = {}) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  let queryString = buildQueryString(params);
  return fetch(`${config.apiUrl}/Invoices?${queryString}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getStatementSummary(params = {}) {
  let queryString = buildQueryString(params);
  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(
    `${config.apiUrl}/Invoices/Summary?${queryString}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getStatementAll(params = {}) {
  let queryString = buildQueryString(params);

  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(
    `${config.apiUrl}/Invoices/Statement?${queryString}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getById(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/${id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function update(payload) {
  let id = payload.id;
  delete payload.id;
  payload.invoice.accountId = accountId();
  const requestOptions = {
    ...customRequest("PUT", payload),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${id}/UpdateWithLines`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function _delete(payload) {
  const requestOptions = {
    ...customRequest("DELETE"),
  };
  return fetch(`${config.apiUrl}/Invoices/${payload.id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: {
          id: payload.id,
          ...response,
        },
      };
    });
}
